export const toHex = (n: number, m: number): string =>
  Math.round((n + m) * 255)
    .toString(16)
    .padStart(2, '0');
